<template>
    <div>
      <BulletinBoard
        :isProd="isProd"
        :api="api"
        :additionalParam="additionalParam"
      >
      </BulletinBoard>
    </div>
    
  </template>
  
  <script>
  import { applyReactInVue } from 'vuereact-combined'
  import { PatientCaseDetail } from '@jdh/content-pc-components';
  import { health_pcs_cat_options, health_pcs_caseDetail_list, health_pcs_caseDetail_setPinned, health_pcs_caseDetail_delete, health_pcs_caseDetail_update, health_pcs_caseDetail_findById } from '../../../../../api/patientCaseDetail';
//   const env = import.meta.env.VITE_ENV
  
  export default {
    components: {
      BulletinBoard: applyReactInVue(PatientCaseDetail)
    },
    props: [],
    name: 'patientCaseDetail',
    data() {
      return {
        api:{
          health_pcs_cat_options, health_pcs_caseDetail_list, health_pcs_caseDetail_setPinned, health_pcs_caseDetail_delete, health_pcs_caseDetail_update, health_pcs_caseDetail_findById
        },
        tenantCode: localStorage.getItem('saas_partnerId'),
        // isProd: env === 'prod'
        isProd: true
      }
    },
    mounted() { 
      // console.log('#bulletin', this.patientId, this.patientPin, this.userCode)
    },
    updated() {
      // console.log('#bulletin updated:', this.patientId, this.patientPin, this.userCode)
    },
  
    methods: {
  
    }
  }
  </script>
  
  <style lang="scss">
  </style>